import {Experience} from '@/services/experienceTypes';

export const experienceNeedLogin = (
  isLogged: boolean,
  experience: Experience,
) => {
  if (
    (!isLogged && (experience.inVilla || experience.id === 36)) ||
    experience.id === 36
  ) {
    return true;
  }
  return false;
};
